module.exports = __webpack_public_path__ + "static/img/7.f67663d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/sp/7.png
// module id = ZplZ
// module chunks = 0